import axios from 'axios'

//历史变更列表
export function getAmdRecList (data) {
  return axios.get(`/manage/amdRec/list`, { params: data })
}

